import type { CSSProperties } from "react";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { VenueStatuses } from "~enums/venueStatuses.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  allowClear?: boolean;
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  style?: CSSProperties;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectVenueStatus = (props: Props) => {
  const { allowClear = true, className, disabled, defaultValue, multiple, style } = props;
  const options = useMemo(
    () =>
      Object.values(VenueStatuses).map((value) => ({
        value,
        label: value,
      })),
    [],
  );

  return (
    <CustomSelect
      style={{ width: "100%", minWidth: "unset", ...style }}
      value={props.value}
      showSearch
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="venueStatus" />}
      allowClear={allowClear}
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectVenueStatus;
